import { render, staticRenderFns } from "./SntChip.vue?vue&type=template&id=209a8c74&scoped=true&"
import script from "./SntChip.vue?vue&type=script&lang=js&"
export * from "./SntChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a8c74",
  null
  
)

export default component.exports